<template>
    <div class="aircraft container">
        <div class="box">
            <div class="level">
                <div class="level-left">
                    <div class="level-item">
                        <p class="heading has-text-weight-bold is-size-5">Aircrafts</p>
                    </div>
                </div>
                <div class="level-right">
                    <div class="level-item">
                        <div class="field has-addons">
                            <p class="control">
                                <button class="create-button button" @click="openCloseAircraftModal">
                                  <span class="icon is-small">
                                      <i class="fas fa-plus-circle"></i>
                                  </span>
                                    <span>Create</span>
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns"  style="justify-content: right;">
                <div class="column has-text-right">
                    <div class="tooltip"><font-awesome-icon class="is-size-5 is-warning" icon="info"/>
                        <div class="tooltiptext">
                            <ul style="list-style: disc outside">
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can see the planes on the current grid.</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can update the information on the current grid.</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can delete the information on the current grid.</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can add a new plane.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!isLoading" class="aircraft-table">
            <table class="table is-narrow is-fullwidth is-narrow is-striped is-bordered animate__animated animate__faster animate__slideInUp">
                <thead>
                <tr>
                    <th>Id</th>
                    <th>Registration</th>
                    <th>Fleet</th>
                    <th>Aircraft Type</th>
                    <th>Basic Mass</th>
                    <th>Basic Index</th>
                    <th>Act</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="aircraft in aircraftList" :key="aircraft.id">
                    <td>{{aircraft.id}}</td>
                    <td>{{aircraft.registration}}</td>
                    <td>{{aircraft.fleet}}</td>
                    <td>{{aircraft.aircraftType}}</td>
                    <td>{{aircraft.basicMass}}</td>
                    <td>{{aircraft.basicIndex}}</td>
                    <td>
                        <button title="Edit" class="button is-small is-light is-info"
                                         @click="editAircraft(aircraft.id)">
                        <font-awesome-icon icon="edit"/>
                        Edit
                        </button>

                        <button title="delete" class="button is-small is-light is-warning"
                                @click="TrydeleteAircraft(aircraft)">
                            <font-awesome-icon icon="box"/>
                            <p style="padding: 2px">Delete</p>
                        </button>

                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-else>
            <loading-button/>
        </div>

        <div class="modal " v-bind:class="{'is-active':isActiveModal}">
            <div class="modal-background" @click="openCloseAircraftModal"></div>
            <div class="modal-card animate__animated animate__zoomIn animate__faster" style="width:40%; height: 40%;">
                <header class="modal-card-head">
                    <p class="modal-card-title">Aircrafts</p>
                    <button class="delete is-large" @click="openCloseAircraftModal" aria-label="close">Close</button>
                </header>
                <section class="modal-card-body" style="width: 100%; height: 100%">
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Registration</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input v-if="aircraft.id != null" class="input " type="text" v-model="aircraft.registration">
                                    <input v-else class="input " type="text" v-model="aircraftForm.registration">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Fleet</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input v-if="aircraft.id != null" class="input " type="text"
                                           v-model="aircraft.fleet">
                                    <input v-else class="input " type="text" v-model="aircraftForm.fleet">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Aircraft Type</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input v-if="aircraft.id != null" class="input " type="text"
                                           v-model="aircraft.aircraftType">
                                    <input v-else class="input " type="text" v-model="aircraftForm.aircraftType">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">BasicMass</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input v-if="aircraft.id != null" class="input " type="text"
                                           v-model="aircraft.basicMass">
                                    <input v-else class="input " type="text" v-model="aircraftForm.basicMass">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Basic Index</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input v-if="aircraft.id != null" class="input " type="text"
                                           v-model="aircraft.basicIndex">
                                    <input v-else class="input " type="text" v-model="aircraftForm.basicIndex">
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">

                    <div v-if="aircraft.id != null" class="field">
                        <div class="control">
                            <button class="create-button button" @click="TryUpdateAircraft(aircraft)">
                                  <span class="icon is-small">
                                     <i class="fas fa-edit"></i>
                                  </span>
                                <span>Update</span>
                            </button>
                        </div>
                    </div>

                    <div v-else class="field">
                        <div class="control">
                            <div class="control">
                                <button class="create-button button" @click="TryAddAircraft(aircraftForm)">
                                  <span class="icon is-small">
                                     <i class="fas fa-save"></i>
                                  </span>
                                    <span>Save</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </footer>
            </div>
        </div>
    </div>
</template>

<script>

    import {createNamespacedHelpers} from "vuex";
    import {loadingMixin} from "../../utils/mixins";
    import LoadingButton from "../../components/ui/LoadingButton";

    const {mapState, mapActions} = createNamespacedHelpers('aircrafts');

    export default {

        name: "Aircrafts",
        mixins: [loadingMixin],
        components: {
            LoadingButton,
        },

        data() {
            return {
                aircraftForm: {
                    id: 0,
                    registration: "",
                    fleet: "",
                    aircraftType: "",
                    basicMass: "",
                    basicIndex: "",
                }
            }
        },

        created() {
            this.TrygetAircrafts();
        },

        methods: {
            ...mapActions([
                "getAircrafts",
                "openCloseAircraftModal",
                "editAircraft",
                "getAircraft",
                "UpdateAircraft",
                "AddAircraft",
                "deleteAircraft"
            ]),

            editAircraft(value) {
                this.openCloseAircraftModal();
                this.getAircraft(value);
            },

            async TrydeleteAircraft(value) {

                await this.$swal({
                    title: '<p style="text-align: left;font-size: 22px;">Do you want to delete aircraft?</p>',
                    html: "", // // buraya sp den dönen mesaj gelsin.
                    showCancelButton: true,
                    cancelButtonText: 'No',
                    cancelButtonColor: '#C5381A',
                    confirmButtonColor: '#1874DA',
                    confirmButtonText: 'Yes',
                }).then(async(response) =>
                {
                    if (response.value)
                    {
                        try {

                                await this.deleteAircraft(value);

                                // this.$notify({
                                //     title: "Success",
                                //     text: "aircraft deleted.",
                                //     type: "success"
                                // });
                                 // buna sanırım gerek yok bi bakalım test et tekrardan...  this.TrygetAircrafts();
                        }
                        catch (e)
                        {
                            //this.$notify({title: "Error", text:"Error on TrydeleteAircraft e: "+ e.message, type: "error"});
                        }
                    }
                });
            },

            async TrygetAircrafts() {
                this.showLoading();
                try {
                    this.getAircrafts();
                } catch (e) {
                    //this.$notify({title: "Error", text:"Error on TrygetAircrafts function e: " +e.message, type: "error"});
                } finally {
                    this.hideLoading();
                }
            },

            async TryUpdateAircraft(value) {
                try {
                    await this.UpdateAircraft(value)
                    this.openCloseAircraftModal()
                    //this.$notify({title: "Success", type: "success", text: "Succesfully Update"})
                } catch (e) {
                    //this.$notify({title: "Error", type: "error", text: "Error on TryUpdateAircraft function e: " + e.message})
                }

                this.TrygetAircrafts();
            },

            async TryAddAircraft(value) {
                try {
                    await this.AddAircraft(value)
                    this.openCloseAircraftModal()
                    //this.$notify({title: "Success", type: "success", text: "Succesfully Adding"})
                    this.addForm = {};
                } catch (e) {
                    //this.$notify({title: "Error", type: "error", text: "Error on TryAddAircraft function e: "+e.message})
                }

                this.TrygetAircrafts();
            },

        },
        computed: {
            ...mapState([
                "aircraftList",
                "isActiveModal",
                "aircraft"
            ])
        }
    }
</script>

<style scoped>
    .aircraft-table thead th {
        color: white;
        background-color: #6a85a7;
        font-style: normal;
        font-size: 20px;
        top: -12px;
        position: sticky;
        z-index: 2;
    }

    .aircraft-table td {
        border: 0px;
    }

    .aircraft-table {

        overflow-y: scroll;
        height: 780px;
    }

    .aircraft-table th {
        top: -12px;
        position: sticky;
        background-color: white;
        z-index: 2;
    }

    .create-button {
        background-color: #6a85a7;
        color: white;
        font-size: 10px;
        font-size: 1.1rem;
        min-height: auto;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar {
        height: 2px;
        width: 8px;
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #6a85a7;
    }

    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        min-width: 400px;
        max-width: 420px;
        background-color: #6a85a7de;
        border:3px solid;
        border-color: #4f4f4f;
        color: #fff;
        border-radius: 6px;
        top: 100%;
        left: 50%;
        margin-left: -366px;
        padding: 10px;
        margin-right: 23px;
        margin-top: 13px;
        font-size: 15px;
        text-align: left;

        /* Position the tooltip */
        position: absolute;
        z-index: 1111;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }

</style>
